<template>
    <div style="overflow: hidden;width: 100%">
        <CommonHeader/>
        <div class="container" style="min-height: calc(100vh - 56px - 88px);">
            <a-row>
                <a-col class="mt-3 mb-3" :span="24">
                    <a-breadcrumb>
                        <a-breadcrumb-item><a href="">首页</a></a-breadcrumb-item>
                        <a-breadcrumb-item>报名</a-breadcrumb-item>
                    </a-breadcrumb>
                </a-col>
            </a-row>
        <page-header-wrapper>
            <!-- PageHeader 第二种使用方式 (v-slot) -->
            <template v-slot:content>
                将一个冗长或用户不熟悉的表单任务分成多个步骤，指导用户完成。
            </template>
            <a-card :bordered="false">
                <a-steps class="steps" :current="currentTab">
                    <a-step title="确认订单信息"/>
                    <a-step title="支付订单"/>
                    <a-step title="完成"/>
                </a-steps>
                <div class="content">
                    <step1 v-if="currentTab === 0" @finish="finish" @nextStep="nextStep" @setOrderId="setOrderId"
                           :projectId="projectId"/>
                    <step2 v-if="currentTab === 1" :orderId="orderId" @nextStep="nextStep" @prevStep="prevStep" @finish="finish"/>
                    <step3 v-if="currentTab === 2" @prevStep="prevStep" @finish="finish"/>
                </div>
            </a-card>
        </page-header-wrapper>
        </div>
        <CommonFooter/>
    </div>
</template>

<script>
    import Step1 from './Step1'
    import Step2 from './Step2'
    import Step3 from './Step3'
    import CommonHeader from '../common/CommonHeader'
    import CommonFooter from '../common/CommonFooter'

    export default {
        name: 'LegalSignIndex',
        components: {
            Step1,
            Step2,
            Step3,
            CommonHeader,
            CommonFooter,
        },
        created() {
            console.log("currentTab")
            console.log(this.currentTab)
        },
        data() {
            return {
                currentTab: 0,
                form: null,
                orderId: '',
                projectId: this.$route.query.id,
            }
        },
        methods: {
            nextStep() {
                console.log(this.currentTab)
                if (this.currentTab < 2) {
                    this.currentTab += 1
                }
            },
            prevStep() {
                if (this.currentTab > 0) {
                    this.currentTab -= 1
                }
            },
            finish() {
                this.currentTab = 2
            },
            setOrderId(value) {
                this.orderId = value
            },
            btn() {
                alert(this.currentTab)
            }
        }
    }
</script>

<style lang="less" scoped>
    .steps {
        max-width: 750px;
        margin: 16px auto;
    }
</style>
